module.exports = __webpack_public_path__ + "assets/candidate-profile-logo.2bb5c456.jpg";